import React from "react";
import LaborAcademics from "../Components/Organisms/LaborAcademics";
import CustomCard from "../Components/Templates/CustomCard";
import PropTypes from "prop-types";
import { Row, Col, Spinner } from "react-bootstrap";
const LaborAcademicsView = (props) => {
    const { defaultData, loading } = props
    return (
        <CustomCard 
            // text="Ya casi terminamos con tu solicitud"
            content={
                <>
                {
                    loading?
                        <Row className="justify-content-center">
                            <Col md={2} className="mb-3">
                                <Spinner animation="grow" role="status" className="string-primary-color" style={{marginBottom: '5px'}} />
                                <span className="visually-hidden">Cargando información, por favor espere...</span>
                            </Col>
                        </Row>
                    :null
                }
                <LaborAcademics defaultData={defaultData} />
                </>                
            }
        />
    );
}
LaborAcademicsView.propTypes = {
    defaultData: PropTypes.object
}
export default LaborAcademicsView;